import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, Trash2, Plus, BellRing } from "lucide-react";
import PageHero from "@/components/PageHero";
import client from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Alerts() {
  const [alerts, setAlerts] = useState([]);
  const [notes, setNotes] = useState([]);
  const [name, setName] = useState("");
  const [threshold, setThreshold] = useState("");

  const load = () => {
    client.get("/alerts").then((r) => setAlerts(r.data)).catch(() => {});
    client.get("/notifications").then((r) => setNotes(r.data)).catch(() => {});
  };
  useEffect(load, []);

  const add = async () => {
    if (!name.trim()) return;
    await client.post("/alerts", { product_name: name, type: threshold ? "price_below" : "on_sale", threshold: threshold ? +threshold : null });
    setName(""); setThreshold(""); toast.success("Alert created"); load();
  };
  const del = async (id) => { await client.delete(`/alerts/${id}`); load(); };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <PageHero image="/img/fridge.jpg" eyebrow="Price watch" title="Alerts & notifications" subtitle="We'll tell you the moment your staples go on sale." testId="alerts-hero" />

      {notes.length > 0 && (
        <div className="bg-white rounded-3xl p-5 pp-shadow">
          <h2 className="font-extrabold text-pp-text flex items-center gap-2 mb-3"><BellRing className="h-5 w-5 text-pp-gold" /> Recent notifications</h2>
          <div className="space-y-2">
            {notes.map((n, i) => (
              <div key={i} className="flex items-start gap-2 rounded-2xl bg-pp-cream p-3">
                <span className="h-2 w-2 mt-1.5 rounded-full bg-pp-gold" />
                <div><p className="font-semibold text-sm text-pp-text">{n.title}</p><p className="text-xs text-pp-muted">{n.body}</p></div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="bg-white rounded-3xl p-5 pp-shadow">
        <h2 className="font-extrabold text-pp-text mb-3">Create a price alert</h2>
        <div className="grid sm:grid-cols-[1fr_140px_auto] gap-2">
          <Input data-testid="alert-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Product e.g. 2% Milk" className="h-11 bg-white" />
          <Input data-testid="alert-threshold" type="number" step="0.01" value={threshold} onChange={(e) => setThreshold(e.target.value)} placeholder="Below $" className="h-11 bg-white" />
          <Button data-testid="alert-add" onClick={add} className="h-11 rounded-full bg-pp-forest"><Plus className="h-4 w-4 mr-1" /> Add</Button>
        </div>
      </div>

      <div className="space-y-2">
        {alerts.length === 0 ? (
          <div className="bg-white rounded-3xl p-8 text-center pp-shadow"><Bell className="h-10 w-10 mx-auto text-pp-fresh" /><p className="mt-2 font-bold text-pp-text">No active alerts</p></div>
        ) : alerts.map((a) => (
          <div key={a.id} data-testid={`alert-${a.id}`} className="bg-white rounded-2xl p-4 pp-shadow flex items-center gap-3">
            <span className="grid place-items-center h-10 w-10 rounded-xl bg-[#EBF7EE] text-pp-forest"><Bell className="h-5 w-5" /></span>
            <div className="flex-1"><p className="font-semibold text-pp-text">{a.product_name}</p>
              <p className="text-xs text-pp-muted">{a.type === "price_below" ? `Notify below $${a.threshold}` : "Notify when on sale"}</p></div>
            <button onClick={() => del(a.id)} className="text-pp-error p-1"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
